import $ from 'jquery';
import videojs from 'video.js';

import _t from 'i18n!nls/videojs';

const KEY_ENTER = 'Enter';
const KEY_SPACE = ' ';

class CPlayToggle extends videojs.getComponent('PlayToggle') {
  startTime;

  endTime;

  constructor(player, options) {
    super(player, options);
    const label = _t('Play');
    this.el_.innerHTML = '<span class="cif-2x cif-fw cif-play"></span>';
    this.el_.innerHTML += `<span class="vjs-control-text">${label}</span>`;
    this.el_.setAttribute('aria-label', label);
    const { isAudio } = options;
    if (isAudio) {
      this.el_.innerHTML = '<span class="cif-fw cif-play"></span>';
    }
    this.startTime = 0;
    this.endTime = 0;
  }

  setStartTime(startTime) {
    this.startTime = startTime;
  }

  setEndTime(endTime) {
    this.endTime = endTime;
  }

  createEl() {
    const el = super.createEl();
    const $el = $(el);
    $el.attr('data-js', 'c-play-control');
    $el.addClass('c-video-control c-play-control');
    return el;
  }

  // this seems to run after player playback begins.
  handlePlay() {
    super.handlePlay();
    const label = _t('Pause');
    this.el_.setAttribute('aria-label', label);
    const controlIcon = $(this.el_).find('span.cif-fw');
    controlIcon.removeClass('cif-play');
    controlIcon.addClass('cif-pause');
    const controlText = $(this.el_).find('span.vjs-control-text');
    controlText.html(label);
  }

  handlePause() {
    super.handlePause();
    const label = _t('Play');
    this.el_.setAttribute('aria-label', label);
    const controlIcon = $(this.el_).find('span.cif-fw');
    controlIcon.removeClass('cif-pause');
    controlIcon.addClass('cif-play');
    const controlText = $(this.el_).find('span.vjs-control-text');
    controlText.html(label);
  }

  loopToStartIfEndOfTrimmedVideo() {
    if (this.endTime && this.player_.currentTime() >= this.endTime) {
      this.player_.currentTime(this.startTime);
    }
  }

  handleKeyDown(e) {
    const isPauseOrPlay = e.key === KEY_ENTER || e.key === KEY_SPACE;
    if (!isPauseOrPlay) {
      super.handleKeyDown(e);
      return;
    }

    e.preventDefault();

    this.loopToStartIfEndOfTrimmedVideo();

    if (this.player_.paused()) {
      this.player_.play();
    } else {
      this.player_.pause();
    }
  }

  handleClick(event) {
    this.loopToStartIfEndOfTrimmedVideo();
    super.handleClick(event);
  }
}

videojs.registerComponent('CPlayToggle', CPlayToggle);
